
/*
    Display for a single user data record,
    which can be expanded to show a form for editing that data
*/

import React from "react";

import UserManangementForm from "../Forms/UserManagementForm";

import DataItem from "../Components/DataItem";

export default class UserData extends React.Component {
    render() {

        const user = this.props.data;

        return (
            <>
                {
                    this.props.expanded 
                    ? <div className="data data-expanded vertical" style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between"            
                    }}>
                        <UserManangementForm data={this.props.data} index={this.props.containerIndex} submit={this.props.updateUser} />
                        <div className="option option-low-vertical"
                            style={{
                                alignSelf:"flex-end",
                                justifySelf:"flex-end",
                                margin: "6px",
                                marginRight: "12px"
                            }}
                            onClick={() => this.props.runOpen(null)}
                        >
                            Close
                        </div>
                    </div>
                    : <div className="data shadow-card" style={{
                        display: "grid",
                        gridTemplateColumns: "9fr 1fr",
                        padding:"8px 8px 8px 32px",
                    }}
                        
                    >
                        <div style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr 1fr 1fr",
                                justifyItems: "start"
                            }}
                            onClick={() => this.props.runOpen(this.props.expanded ? null : this.props.containerIndex)}
                        >
                            <div>
                                Name: <DataItem val={`${user.userfname}${user.usermname ? " " + user.usermname : ""} ${user.userlname}`} />
                            </div>
                            <div>
                                Username: <DataItem val={user.username} />
                            </div>
                            <div>
                                Role: <DataItem val={user.role} />
                            </div>
                            <div>
                                Group: <DataItem val={user.groupID} />
                            </div>
                            
                            <div style={{gridColumn: "1/4"}}>
                                Location: <DataItem val={user.currentLocation ? user.currentLocation.location_id : ""} />
                            </div>
                            <div>
                                Status: <DataItem val={user.status} />
                            </div>
                        </div>
                        <div className="option" onClick={() => this.props.deleteUser(this.props.containerIndex)}>
                            DELETE
                        </div>
                    </div>
                }
            </>            
        );
    }
}